import React from 'react';
import { Slider } from '@mui/material';
import {
  FormRow,
  FormLabel,
  FormFieldWrapper,
  FormRowProps
} from '../form-input';

export interface SliderFieldProps extends FormRowProps {
  label: string;
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
  marks?: { value: number; label: string | number }[];
}

export function SliderField(props: SliderFieldProps) {
  const {
    label,
    value,
    onChange,
    min = 0,
    max = 100,
    step = 1,
    marks,
    ...formRowProps
  } = props;

  const handleChange = (_: unknown, newValue: number | number[]) => {
    onChange(newValue as number);
  };

  return (
    <FormRow {...formRowProps}>
      <FormLabel>{label}</FormLabel>
      <FormFieldWrapper>
        <Slider
          value={value}
          onChange={handleChange}
          valueLabelDisplay="auto"
          step={step}
          min={min}
          max={max}
          marks={marks}
        />
      </FormFieldWrapper>
    </FormRow>
  );
}
